import './App.css';
import '@ant-design/v5-patch-for-react-19';
import {Auth} from './auth/Auth';
import {Logout} from'./auth/Logout';
import {TabController} from './ui/TabController';
import {useState, useCallback, useEffect} from 'react'
import { BrowserRouter, Routes, Route } from "react-router";
import {InventoryTab} from "./ui/inventory/InventoryTab";
import {
    setPermissions,
    checkPerm
} from "./auth/sessionTools";
import {SalesTab} from "./ui/sales/SalesTab";
import {BuyerTab} from "./ui/buyer/BuyerTab";
import {ReturnTab} from "./ui/returns/ReturnTab";
import {AccountingTab} from "./ui/accounting/AccountingTab";
import {ProductView} from "./ui/inventory/ProductView";
import {GeneralTab} from "./ui/general/GeneralTab";
import {InvoiceView} from "./ui/sales/InvoiceView";
import {FulfillmentTab} from "./ui/fulfillment/FulfillmentTab";
import {BuyerView} from "./ui/buyer/BuyerView";
import {VendorView} from "./ui/Contacts/VendorView";
import {PurchaseOrderView} from "./ui/fulfillment/PurchaseOrderView";
import {POLineItemView} from "./ui/fulfillment/POLineItemView";
import {AdminTab} from "./ui/Admin/AdminTab";
import {ContactTab} from "./ui/Contacts/ContactTab";
import {ProfitReport} from "./ui/accounting/ProfitReport";
import {InventoryView} from "./ui/inventory/InventoryView";
import {TaskTab} from "./ui/tasks/TaskTab";
import {TaskView} from "./ui/tasks/TaskView";
import {REFRESH_PERIOD} from "./api/Constants";
import {toMs} from "./util/timeutils";
import {CultivationTab} from "./ui/cultivation/CultivationTab";
import {ManufacturingTab} from "./ui/manufacturing/ManufacturingTab";
import {OperationsTab} from "./ui/operations/OperationsTab";
import {GraphicsTab} from "./ui/graphics/GraphicsTab";
import {RetailTab} from "./ui/retail/RetailTab";
import {LocationTab} from "./ui/location/LocationTab";

function App() {
    const [session, setSession] = useState([]);
    const [authorized, setAuthorized] = useState(false);
    const [numTasks, setNumTasks] = useState(0);

    const authComplete = useCallback((access) => {
        console.log(`authComplete ${JSON.stringify(access)}`);
        setAuthorized(true);
        setPermissions(access);
        setSession(access);
    }, []);

    const onFail = () => {
        setAuthorized(false);
        console.log(`login failed`);
    }

    const [refresh, setRefresh] = useState(0);

    const onRefresh = useCallback(() => {
        setRefresh(refresh+1)
    }, [refresh])

    useEffect(() => {
        const refreshInterval = setInterval(() => {
            onRefresh();
        }, toMs(REFRESH_PERIOD));
        return () => {
            clearInterval(refreshInterval);
        }
    }, [onRefresh]);

    const LogoutButton = <div style={{display: 'grid', gridTemplateColumns: '5fr 1fr'}}>
        <div />
        <div style={{display: 'grid', gridTemplateColumns: '1fr auto'}}>
            <div />
            <div><Logout onLogout={onFail}/></div>
        </div>
    </div>

    const isSales = checkPerm(session, "sales");
    const isAccounting = checkPerm(session, "accounting");
    const hasExecutivePerm = checkPerm(session, "executive");
    const hasFulfillmentPerm = checkPerm(session, "fulfillment");
    const hasInventory = checkPerm(session, "inventory");
    const isCultivation = checkPerm(session, "cultivation");
    const isManufacturing = checkPerm(session, "manufacturing");
    const isOps = checkPerm(session, "operations");
    const isGraphics = checkPerm(session, "graphics");
    const isTrapcon = checkPerm(session, "trapconretail");

    return (
        <div className="App">
            <b>Coast Demo</b>
            <p />
            {authorized ? LogoutButton : <div />}
            <Auth authorized={authorized} onComplete={authComplete} onFail={onFail}>
                <BrowserRouter>
                    <Routes>
                        <Route path={'/'} element={<TabController onApiFail={onFail} session={session} numTasks={numTasks}/>}>
                            <Route index element={<GeneralTab />} />
                            <Route path={'general'} element={<GeneralTab />} />
                            <Route path={'tasks'} element={<TaskTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />
                            <Route path={'location'} element={<LocationTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />
                            <Route path={'contacts'} element={<ContactTab refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />
                            {hasInventory && <Route path={'inventory'} element={<InventoryTab refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />}
                            {isSales && <Route path={'sales'} element={<SalesTab session={session} onApiFail={onFail} refresh={refresh} onRefresh={onRefresh} />} />}
                            {isSales && <Route path={'buyers'} element={<BuyerTab refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {isSales && <Route path={'returns'} element={<ReturnTab refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {hasFulfillmentPerm && <Route path={'fulfillment'} element={<FulfillmentTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />}
                            {isCultivation && <Route path={'cultivation'} element={<CultivationTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />}
                            {isManufacturing && <Route path={'manufacturing'} element={<ManufacturingTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {isOps && <Route path={'operations'} element={<OperationsTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {isGraphics && <Route path={'graphics'} element={<GraphicsTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {isTrapcon  && <Route path={'trapconretail'} element={<RetailTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {isAccounting && <Route path={'accounting'} element={<AccountingTab session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />}
                            {hasExecutivePerm && <Route path={'admin'} element={<AdminTab refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} /> } />}
                            <Route path={'product/:productId'} element={<ProductView refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />
                            <Route path={'invoice/:invoiceId'} element={<InvoiceView refresh={refresh} onRefresh={onRefresh} onApiFail={onFail}/>} />
                            <Route path={`purchaseorder/:purchaseId/lineItem/:lineId`} element={<POLineItemView onApiFail={onFail} refresh={refresh} onRefresh={onRefresh} />} />
                            <Route path={`purchaseorder/:purchaseId`} element={<PurchaseOrderView session={session} onApiFail={onFail} refresh={refresh} onRefresh={onRefresh}/>} />
                            <Route path={'buyer/:buyerId'} element={<BuyerView refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />
                            <Route path={'vendor/:vendorId'} element={<VendorView refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />
                            <Route path={'report/profit'} element={<ProfitReport refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />
                            <Route path={'inventory/:inventoryId'} element={<InventoryView refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />
                            <Route path={'task/:taskId'} element={<TaskView session={session} refresh={refresh} onRefresh={onRefresh} onApiFail={onFail} />} />
                            <Route path={'*'} element={<div>Not Found</div>} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </Auth>
        </div>
    );
}

export default App;
